import { render, staticRenderFns } from "./formio-render.vue?vue&type=template&id=221acf27&"
import script from "./formio-render.vue?vue&type=script&lang=js&"
export * from "./formio-render.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports